export interface ApiConfig {
    API_URL: string;
}

const win: ApiConfig = {
    API_URL: 'http://localhost:5196/',
    // API_URL: 'http://192.168.88.240:5196/',
};

const mac: ApiConfig = {
    API_URL: 'http://localhost:5196/',
};

const production: ApiConfig = {
    API_URL: 'https://sce-api.inerps.eu/',
};

const stage: ApiConfig = {
    API_URL: 'https://stage-sce-api.inerps.eu/',
}
const environments = {
    win,
    mac,
    production,
    stage
}

//@ts-ignore
export const apiConfig: ApiConfig = environments[process.env.REACT_APP_STAGE];
